import { defineType } from 'sanity';

export const statistics = defineType({
    name: 'statistics',
    title: 'Statistics section',
    type: 'object',
    fields: [
        {
            name: 'stats',
            title: 'Statistics',
            type: 'array',
            of: [
                {
                    type: 'object',
                    fields: [
                        {
                            name: 'value',
                            title: 'Value',
                            type: 'localizedString',
                        },
                        {
                            name: 'label',
                            title: 'Label',
                            type: 'localizedString',
                        },
                    ],
                },
            ],
        },
        {
            name: 'variant',
            title: 'Variant',
            type: 'string',
            options: {
                list: [
                    { title: 'Variant A', value: 'A' },
                    { title: 'Variant B', value: 'B' },
                    { title: 'Variant C', value: 'C' },
                ],
            },
        },
    ],
    preview: {
        select: {
            stats: 'stats',
        },
        prepare(selection) {
            const { stats } = selection;
            return {
                title: `Statistics section with ${stats.length} stats`,
            };
        },
    },
});
